export const aiEnhancementsContinueBtnDataSet = { cy: 'introEnhancements-continue-btn' };
export const subtitlesToggleDataSet = { cy: 'subtitles-toggle-btn' };
